import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(({typgrphy, v2}: any) => ({
    introText: {
        fontSize: (v2 ? typgrphy.bodyNormal.fontSize : '14px') + ' !important',
        paddingBottom: 12,
    },
}));
